<template>
  <div>
    <div class="err-Book-info-box">
      <div class="books-box" @click="Detailx()">
        <div class="book-cover">
          <el-image :src="goodinfo.coverFileUrl" fit=""></el-image>
        </div>
        <div class="book-text">
          <p class="name">{{ goodinfo.title }}</p>
          <p class="number">共 {{ total }} 个错题</p>
        </div>
      </div>
      <div class="switch_box">
        <el-switch v-model="removeTest" @change="switchChange" active-text="">
        </el-switch>
        <p>答对后自动移除错题</p>
      </div>
    </div>
    <div style="width: 100%; height: 30px; background-color: #f2f2f2"></div>
    <div class="Wrong-question-box">
      <div class="title">错题列表</div>
      <div class="err-top-bar">
        <div>
          <div>
            <el-checkbox
              v-model="selAll"
              :indeterminate="isIndeterminate"
              @change="changeAll"
            ></el-checkbox>
          </div>
          <div class="menu-bar">
            <el-dropdown
              size="medium"
              @command="switchSourceType"
              style="width: 170px"
            >
              <el-button class="menu-btn" type="text">
                {{ currentSourceTypeText
                }}<i class="el-icon-caret-bottom el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="1"
                  >答题时间由近到远</el-dropdown-item
                >
                <el-dropdown-item command="0"
                  >答题时间由远到近</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown size="medium" @command="switchSourceType2">
              <el-button class="menu-btn" type="text">
                {{ currentSourceTypeText2
                }}<i class="el-icon-caret-bottom el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-show="judgeRightOrWrong.includes(item.questionType)"
                  v-for="(item, index) in paperType"
                  :key="index"
                  :command="item.questionType"
                  >{{ item.name }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div @click="del_show = true" v-if="!del_show">
          <img src="../../../assets/icon/del_01.png" alt="" />
          <p>删除</p>
        </div>
        <div v-if="del_show">
          <div @click="delBtn()">
            <p style="color: #ff4141; width: 50px">删除</p>
          </div>
          <div @click="del_show = false">
            <p>取消</p>
          </div>
        </div>
      </div>
      <div
        style="
          width: 1400px;
          height: 1px;
          background: #f2f2f2;
          margin-top: 20px;
          margin-left: -15px;
        "
      ></div>
      <div class="error-list">
        <el-checkbox-group v-model="checkList" :max="10">
          <div class="card_list" v-for="(item, index) in errList" :key="index">
            <div>
              <el-checkbox
                v-if="del_show"
                :label="item.questionId"
                @change="checkChange(item.questionId)"
                class="checkbox"
              ></el-checkbox>

              <div
                class="topic"
                @click="toDetail(index)"
                v-html="JSON.parse(item.stem).content"
              ></div>
            </div>

            <div class="text">
              <div class="type">{{ callPaperType(item.questionType) }}</div>
              <div class="errnum">
                共答题 {{ item.answerNum ? item.answerNum : 1 }} 次，做错
                <span>{{ item.wrongNum ? item.wrongNum : 1 }}</span> 次
              </div>
            </div>
          </div>
        </el-checkbox-group>
      </div>

      <div class="pagination-box">
        <el-pagination
          class="ou-pagination"
          background
          hide-on-single-page
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.pageNum"
          :page-size="searchParams.pageSize"
          :total="total"
        >
          <el-button @click="getErrorBookList()" class="ou-page-go"
            >GO</el-button
          >
        </el-pagination>
        <noData v-if="total == 0"></noData>
      </div>
      <div style="width: 1200px" v-if="total > 0">
        <el-button
          v-if="!del_show"
          @click="toDetail()"
          style="width: 1000px; margin-left: 150px"
          type="primary"
          >开始练习</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import {
  selWrongQuestionListByGoodId,
  delWrongQuestion,
} from "@/api/willingLearn/index.js";
import noData from "@/components/noData.vue";
export default {
  components: { noData },
  data() {
    return {
      del_show: false,
      searchParams: {
        pageNum: 1,
        pageSize: 10,
        messageTitle: "",
        isDesc: 0,
        questionType: "0",
      },
      removeTest: false,
      paperTypeList: this.paperTypeList(),
      selAll: false,
      isIndeterminate: false,
      checkList: [],
      total: 0,
      errList: [],
      goodinfo: {},
      paperType: [],
      judgeRightOrWrong: [],
    };
  },
  created() {
    localStorage.getItem("automatically-removeV2")
      ? (this.removeTest =
          localStorage.getItem("automatically-removeV2") == "true")
      : "";
    this.goodinfo = this.$route.query;
    this.judgeRightOrWrong = this.$store.getters.judgeRightOrWrong;
    this.paperType = this.$store.getters.paperType;
    this.paperType.unshift({
      questionType: "0",
      name: "全部",
    });
    // 浏览器切换到当前tab浏览页调用
    // this.$once("hook:beforeDestroy", () => {
    //   document.removeEventListener("visibilitychange", this.visibilitychange);
    // });
  },
  computed: {
    ...mapGetters(["avatar"]),
    currentSourceTypeText() {
      let dict = {
        0: "答题时间由远到近",
        1: "答题时间由近到远",
      };
      return dict[this.searchParams.isDesc];
    },
    currentSourceTypeText2() {
      let dict = this.paperType;
      return dict[this.searchParams.questionType].name;
    },
  },
  mounted() {
    this.geterrlist();
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") {
        this.errList = [];
        this.geterrlist();
      }
    });
  },
  methods: {
    Detailx() {
      this.$router.push({
        path: "/bookstore/generateQuestion",
        query: {
          goodsId: this.$route.query.goodId,
        },
      });
    },
    //获取错题
    geterrlist() {
      let data = {
        questionType:
          this.searchParams.questionType == "0"
            ? ""
            : this.searchParams.questionType,
        isDesc: this.searchParams.isDesc == 1 ? "1" : "0",
        pageNum: this.searchParams.pageNum,
        pageSize: this.searchParams.pageSize,
        goodId: this.$route.query.goodId,
      };
      selWrongQuestionListByGoodId(data).then((res) => {
        this.errList = res.rows;
        console.log(this.errList);
        this.total = res.total;
      });
    },
    visibilitychange() {},

    switchChange(e) {
      localStorage.setItem("automatically-removeV2", e);
    },
    changeAll(e) {
      this.selAll = e;
      this.isIndeterminate = false;
      let list = [];
      this.errList.map((item, index) => {
        list.push(item.questionId);
      });
      this.checkList = e ? list : [];
      console.log(this.checkList);
    },
    checkChange(value) {
      this.isIndeterminate =
        this.checkList.length > 0 &&
        this.checkList.length < this.errList.length;
      this.selAll = this.errList.length === this.checkList.length;
    },

    delBtn() {
      if (this.checkList.length) {
        this.$confirm("是否要删除该错题?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          delWrongQuestion({
            questionIds: this.checkList.toString(),
          }).then(() => {
            // this.getErrorBookList();
            this.geterrlist();
          });
        });
      } else {
        this.$message.error("请至少选中一条数据");
      }
    },
    switchSourceType(value) {
      this.searchParams.isDesc = value;
      this.geterrlist();
    },
    switchSourceType2(value) {
      this.searchParams.questionType = value;
      this.geterrlist();
    },
    handleSizeChange(val) {
      this.searchParams.pageSize = val;
      this.geterrlist();
    },
    handleCurrentChange(val) {
      this.searchParams.pageNum = val;
      this.geterrlist();
    },
    removeStyle(e) {
      e = e.replace(/<[^>]+>/g, ""); //去除所有标签，以纯文本展示
      e = e.replace(/\s/gi, ""); //去除空格
      return e;
    },
    // 跳转
    toDetail(index) {
      let routeUrl = this.$router.resolve({
        path: "/user/errorBookV2/testPaper",
        query: {
          goodId: this.goodinfo.goodId,
          errorBookIndex: index,
          questionType: this.searchParams.questionType,
          isDesc: this.searchParams.isDesc,
          pageNum: this.searchParams.pageNum,
          pageSize: this.total,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>
<style scoped lang="scss">
.err-Book-info-box {
  width: 100%;
  height: 120px;
  padding: 15px 28px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .books-box {
    display: flex;
    align-items: center;
    cursor: pointer;

    .book-cover {
      width: 87px;
      height: 87px;
      margin-right: 17px;

      .el-image {
        width: 100%;
        height: 100%;
      }
    }
    .book-text {
      .name {
        width: 300px;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 21px;
        margin-bottom: 15px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .number {
        font-size: 13px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 21px;
        margin-top: 15px;
      }
    }
  }

  .switch_box {
    display: flex;
    align-items: center;
    p {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      margin-left: 6px;
    }
  }
}
.Wrong-question-box {
  padding: 19px 15px;
  box-sizing: border-box;

  .title {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    margin-bottom: 20px;
  }

  .err-top-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;

    > div {
      display: flex;
      align-items: center;
      cursor: pointer;
      img {
        width: 15px;
        height: 15px;
        margin-right: 2px;
      }
      p {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
      }
    }
    .menu-bar {
      padding: 0 10px;
      .el-button {
        color: #666666;
        padding: 0;
      }
    }
  }

  .error-list {
    .card_list {
      width: calc(100% - 80px);
      // height: 68px;
      border-bottom: 1px solid #f2f2f2;
      // margin: 0 40px;
      padding: 25px 0 15px 0;
      box-sizing: border-box;

      > div {
        display: flex;
        align-items: center;
      }

      .topic {
        width: 100%;
        height: 28px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 28px;
        cursor: pointer;
      }

      .text {
        margin-top: 19px;
        margin-left: 30px;
        .type {
          width: 80px;
          height: 28px;
          background: #ffa83a;
          border-radius: 6px;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #ffffff;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 20px;
          flex-shrink: 0;
        }

        .errnum {
          width: 250px;
          height: 20px;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #333333;

          span {
            color: #ff4141;
          }
        }
      }

      .checkbox {
        margin-right: 15px;
        ::v-deep .el-checkbox__label {
          display: none;
        }
      }
    }
  }
}
.pagination-box {
  text-align: right;
  margin: 25px 40px;
}
</style>
